/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const Q_ally_no_bless = require('./Q_ally_no_bless');
const Q_injured_ally_cluster = require('./Q_injured_ally_cluster');
const BattleCalc = require('../../BattleCalc');
const AICalc = require('../AICalc');

const SupportDecision = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.NO] = new Q_ally_no_bless(actor, battleState);
  node.branches[node.YES] = new Q_injured_ally_cluster(
    actor,
    battleState,
    node.branches[node.NO]
  );

  node.getMostInjuredAlly = function () {
    var mostInjured = null;
    var lowestHPRatio = 1.0;

    let allies = BattleCalc.getAlliesOfUnit(
      actor,
      battleState.allUnits,
      true,
      false // never heal summons
    );

    for (const unit of allies) {
      const unitHPRatio = unit.hp / unit.max_hp;

      if (unitHPRatio < lowestHPRatio) {
        mostInjured = unit;
        lowestHPRatio = unitHPRatio;
      }
    }

    return mostInjured;
  };

  node.query = function () {
    const mostInjured = this.getMostInjuredAlly();

    if (this.yesNoEvalFunction(mostInjured)) {
      return this.branches[this.YES].query(mostInjured);
    } else {
      return this.branches[this.NO].query();
    }
  };

  node.yesNoEvalFunction = function (mostInjured) {
    return (
      mostInjured &&
      BattleCalc.unitHPBelowPercent(
        mostInjured,
        AICalc.SUPPORT_DECISION_LOW_HP_THRESHOLD
      )
    );
  };

  return node;
};
module.exports = SupportDecision;
